import PolicyPage from "@/components/legal/PolicyPage";
import { POLICY_PAGES } from "@/constants/policies";

export default function PrivacyPolicy() {
  return <PolicyPage policy={POLICY_PAGES.privacy} />;
}
